








































































































import {
  computed,
  defineComponent,
  inject,
  onBeforeUnmount,
  onMounted,
  PropType,
  provide,
  reactive,
  ref,
  toRefs,
  useStore,
  watch
} from '@nuxtjs/composition-api'
import { isEqual } from 'lodash-es'
import { assignReactive } from '~/components/logics/utils'
import SearchConditionSelect from '~/components/organisms/DS2/SearchConditionSelect'
import SearchConditionSelectModal from '~/components/organisms/DS2/SearchConditionSelectModal'
import { serviceSearchOptionValue } from '~/stub/apigateway/master/master_pb'
import { SearchServiceCondition } from '~/stub/apigateway/service/search_pb'
import {
  ChangeConditionObject,
  ConditionOptionCommon,
  ConditionOptionGroup,
  GroupedConditionOptions,
  Price
} from '~/types/services/search'
import { SERVICE_KIND_VALUE } from '~/constants/search'

export const FACET_GROUP = Object.freeze({
  METHODS: {
    key: 'methods',
    label: '提供方法'
  },
  RANGES: {
    key: 'ranges',
    label: '対応範囲'
  },
  PROVIDERS: {
    key: 'providers',
    label: '出品者情報'
  },
  PRICES: {
    key: 'prices',
    label: '予算'
  },
  DELIVERIES: {
    key: 'deliveries',
    label: 'お届け日数'
  },
  ALL: {
    key: 'all',
    label: '検索条件を絞り込む'
  }
})

/**
 * 絞り込み条件の初期値を生成する
 */
function getEmptySearchConditionStateAll(groupedConditionOptions: GroupedConditionOptions) {
  const condition = {}
  // PRO認定優先表示は全Facetグループで出るのでループの外で値をセット
  condition['pro_priority_display'] = ''
  condition['certification_divination_priority_display'] = ''
  Object.values(groupedConditionOptions).forEach((groupedConditionOption: ConditionOptionGroup) => {
    groupedConditionOption.options.forEach(option => {
      // サービス価格の時はpriceMinとpriceMaxのキーに値を設定する
      if (option.master.key === 'service_price_range') {
        condition['price_min'] = undefined
        condition['price_max'] = undefined
        return
      }
      // 文字単価
      if (option.master.key === 'unit_price') {
        condition['unit_price_min'] = undefined
        condition['unit_price_max'] = undefined
        return
      }
      if (option.master.key === 'provider_status') {
        condition['provider_statuses'] = []
        condition['reservation_available_flag'] = ''
        return
      }
      if (option.master.key === 'additional_options') {
        condition['provider_statuses'] = []
        condition['customize_flag'] = ''
        condition['shipment_flag'] = ''
        return
      }
      if (option.master.key === 'identification_status') {
        condition['identification_flag'] = ''
        condition['nda_conclusion_flag'] = ''
        return
      }
      if (option.master.key === 'provider_level_ids') {
        condition['provider_level_ids'] = []
        return
      }
      if (option.master.key === 'service_kind') {
        condition['service_kind'] = ''
        return
      }

      if (option.master.type === 'checkbox') {
        condition[option.master.key] = []
      } else if (option.master.type === 'radio') {
        condition[option.master.key] = ''
      } else if (option.master.type === 'price_range') {
        // 文字単価のとき
        condition[option.master.key] = []
      }
    })
  })
  return condition
}

// TODO: category_v2 一旦そのままexportしたが、別ファイルにするかは別途検討する
/**
 * 絞り込み条件を選択されていたオプションの状態に復元する
 */
export function getSearchConditionStateAll(
  groupedConditionOptions: GroupedConditionOptions,
  searchCondition: SearchServiceCondition.AsObject
) {
  const condition = {}
  // PRO認定優先表示は全Facetグループで出るのでループの外で値をセット
  condition['pro_priority_display'] = searchCondition.proPriorityDisplay || ''
  condition['certification_divination_priority_display'] =
    searchCondition.certificationDivinationPriorityDisplay || ''
  Object.values(groupedConditionOptions).forEach((groupedConditionOption: ConditionOptionGroup) => {
    groupedConditionOption.options.forEach(option => {
      // 価格のFacetグループと全部入りのFacetグループの時にサービス価格と文字単価の状態をセットする
      if (
        groupedConditionOption.key === FACET_GROUP.PRICES.key ||
        groupedConditionOption.key === FACET_GROUP.ALL.key
      ) {
        // サービス価格の時はpriceMinとpriceMaxのキーに値を設定する
        condition['price_min'] = Number(groupedConditionOption.price.priceMin) || undefined
        condition['price_max'] = Number(groupedConditionOption.price.priceMax) || undefined

        // 文字単価
        // ビデオと電話の時は文字単価の値の状態をリセットする
        if (
          searchCondition.serviceKind === SERVICE_KIND_VALUE.PHONE ||
          searchCondition.serviceKind === SERVICE_KIND_VALUE.VIDEO
        ) {
          condition['unit_price_min'] = undefined
          condition['unit_price_max'] = undefined
        } else {
          condition['unit_price_min'] =
            Number(groupedConditionOption.price.unitPriceMin) || undefined
          condition['unit_price_max'] =
            Number(groupedConditionOption.price.unitPriceMax) || undefined
        }
        return
      }
      // 出品者状況
      if (option.master.key === 'provider_status') {
        condition['provider_statuses'] = searchCondition.providerStatusesList || []
        condition['reservation_available_flag'] = searchCondition.reservationAvailableFlag || ''
        return
      }
      // 追加オプション
      if (option.master.key === 'additional_options') {
        condition['provider_statuses'] = searchCondition.providerStatusesList || []
        condition['customize_flag'] = searchCondition.customizeFlag || ''
        condition['shipment_flag'] = searchCondition.shipmentFlag || ''
        return
      }
      // 認証状況
      if (option.master.key === 'identification_status') {
        condition['identification_flag'] = searchCondition.identificationFlag || ''
        condition['nda_conclusion_flag'] = searchCondition.ndaConclusionFlag || ''
        return
      }
      // 出品者ランク
      if (option.master.key === 'provider_level_ids') {
        condition['provider_level_ids'] = searchCondition.providerLevelIdsList || []
        return
      }
      // サービスの種類
      if (option.master.key === 'service_kind') {
        condition['service_kind'] = searchCondition.serviceKind || ''
        return
      }

      if (option.master.type === 'checkbox') {
        condition[option.master.key] = option.option.valuesList || []
      } else if (option.master.type === 'radio') {
        condition[option.master.key] = option.option.value || ''
      } else if (option.master.type === 'price_range') {
        // 文字単価のとき
        condition[option.master.key] = option.option.valuesList || []
      }
    })
  })
  return condition
}

const serviceSearchCondition = defineComponent({
  name: 'ServiceSearchCondition',
  components: {
    SearchConditionSelect,
    SearchConditionSelectModal
  },
  props: {
    conditionOptionsCommon: {
      type: Array as PropType<ConditionOptionCommon[]>,
      default: () => []
    },
    condition: {
      type: Object as PropType<SearchServiceCondition.AsObject>,
      default: () => ({})
    }
  },
  setup(props, context) {
    const store = useStore()
    const { conditionOptionsCommon, condition } = toRefs(props)
    const isFixed = ref<boolean>(false)
    const elRoot = ref<HTMLElement>()

    // TODO:category_v2 型解決の方法がわからなかったので一旦ignore
    // 各ボタンの中の絞り込み項目のデータを生成する
    //@ts-ignore
    const groupedConditionOptions = computed<GroupedConditionOptions>(() => {
      // TODO: category_v2 初期値を生成する処理は後でリファクタリングしたい。
      // 提供方法・対応範囲などの各ブロックごとの初期値を作成
      const option = {
        [FACET_GROUP.METHODS.key]: {
          key: FACET_GROUP.METHODS.key,
          label: FACET_GROUP.METHODS.label,
          options: [],
          price: {
            priceMin: null,
            priceMax: null,
            unitPriceMin: null,
            unitPriceMax: null
          }
        },
        [FACET_GROUP.RANGES.key]: {
          key: FACET_GROUP.RANGES.key,
          label: FACET_GROUP.RANGES.label,
          options: [],
          price: {
            priceMin: null,
            priceMax: null,
            unitPriceMin: null,
            unitPriceMax: null
          }
        },
        [FACET_GROUP.PROVIDERS.key]: {
          key: FACET_GROUP.PROVIDERS.key,
          label: FACET_GROUP.PROVIDERS.label,
          options: [],
          price: {
            priceMin: null,
            priceMax: null,
            unitPriceMin: null,
            unitPriceMax: null
          }
        },
        [FACET_GROUP.PRICES.key]: {
          key: FACET_GROUP.PRICES.key,
          label: FACET_GROUP.PRICES.label,
          options: [],
          price: {
            priceMin: null,
            priceMax: null,
            unitPriceMin: null,
            unitPriceMax: null
          }
        },
        [FACET_GROUP.DELIVERIES.key]: {
          key: FACET_GROUP.DELIVERIES.key,
          label: FACET_GROUP.DELIVERIES.label,
          options: [],
          price: {
            priceMin: null,
            priceMax: null,
            unitPriceMin: null,
            unitPriceMax: null
          }
        }
      }
      // 検索のレスポンスで返ってきた絞り込み条件をセット
      conditionOptionsCommon.value.forEach(conditionOption => {
        if (conditionOption.master.facetGroupKey) {
          option[conditionOption.master.facetGroupKey].options.push(conditionOption)
          // 予算の項目では最低価格と最高価格の情報を設定
          if (conditionOption.master.facetGroupKey === FACET_GROUP.PRICES.key) {
            const unitPriceMin = conditionOption.option.min?.value
            const unitPriceMax = conditionOption.option.max?.value
            // サービス価格と文字単価の価格の初期値を設定する
            option[conditionOption.master.facetGroupKey].price = {
              priceMin: condition.value.priceMin,
              priceMax: condition.value.priceMax,
              unitPriceMin: unitPriceMin,
              unitPriceMax: unitPriceMax
            }
          }
        }
      })
      return option
    })

    // 全部入りの絞り込み条件の作成
    const allConditionOptions = computed<ConditionOptionGroup>(() => {
      const options = []
      Object.values(groupedConditionOptions.value).forEach(
        (groupedCondition: ConditionOptionGroup) => {
          options.push(...groupedCondition.options)
        }
      )

      // 選択した絞り込み条件
      const priceCondition = conditionOptionsCommon.value.find(
        conditionOption => conditionOption.master.facetGroupKey === FACET_GROUP.PRICES.key
      )
      const price: Price = {
        priceMin: Number(condition.value.priceMin),
        priceMax: Number(condition.value.priceMax),
        unitPriceMin: Number(priceCondition.option.min?.value),
        unitPriceMax: Number(priceCondition.option.max?.value)
      }

      return {
        key: FACET_GROUP.ALL.key,
        label: FACET_GROUP.ALL.label,
        options,
        price
      }
    })

    // 空っぽの状態の絞り込み条件のデータフォーマットを作成
    const emptySearchConditionAll = getEmptySearchConditionStateAll(groupedConditionOptions.value)
    // 選択済みの絞り込み条件のりアクティブで管理
    const selectedSearchConditionAll = reactive(
      getSearchConditionStateAll(groupedConditionOptions.value, condition.value)
    )
    provide('selectedSearchConditionAll', selectedSearchConditionAll)

    // 検索実行後に選択中の状態を更新する
    watch(condition, () => {
      assignReactive(
        selectedSearchConditionAll,
        getSearchConditionStateAll(groupedConditionOptions.value, condition.value)
      )

      assignReactive(selectedSearchConditionAllClone, { ...selectedSearchConditionAll })
    })

    // 絞り込み条件が変更されたかどうか
    const isConditionChanged = ref<boolean>(false)
    // 状態比較用に選択済絞り込み条件の値をクローン
    const selectedSearchConditionAllClone = reactive({ ...selectedSearchConditionAll })

    watch(selectedSearchConditionAll, newVal => {
      // サービスの種類が未選択の際、提供可能オプションのいずれかを選択した場合にtrueになる
      if (
        newVal['service_kind'] === '' &&
        (newVal['shipment_flag'] || newVal['customize_flag'] || newVal['provider_statuses'].includes('video_service'))
      ) {
        const cloneNewCondition = { ...newVal }
        // サービスの種類に通常サービスを設定
        cloneNewCondition['service_kind'] = SERVICE_KIND_VALUE.TEXT
        Object.assign(selectedSearchConditionAll, cloneNewCondition)
        // ↑でselectedSearchConditionAllを更新しているためwatch内の処理が再び実行されることになるので、
        // 以降の処理は再実行時に任せる
        return
      }
      // 選択状態を比較して、変更してた時にはボタンを有効化する
      const state = { ...newVal }
      isConditionChanged.value = !isEqual(state, selectedSearchConditionAllClone)
    })

    const isPC = computed<boolean>(() => {
      return store.getters['ui/isPC']
    })
    watch(isPC, newVal => {
      if (!newVal) {
        isFixed.value = false
        context.emit('switch-position', false)
      }
    })

    /**
     * 絞り込み条件項目の表示位置を切り変える
     * 絞り込み項目が画面の表示領域から出たら上部固定、画面内に入ったら固定解除
     */
    let isTicking = false
    const switchSearchConditionPosition = (): void => {
      if (!isPC.value) {
        return
      }
      if (!isTicking) {
        window.requestAnimationFrame(() => {
          isTicking = false
          const searchConditionPosition =
            elRoot.value?.getBoundingClientRect().top + window.pageYOffset
          const scrollY = window.scrollY
          isFixed.value = searchConditionPosition < scrollY
          context.emit('switch-position', isFixed.value)
        })
        isTicking = true
      }
    }

    /**
     * 絞り込み対象のキーを返す
     */
    const getSearchConditionKeys = (facetGroupKey: string): string[] => {
      const priceConditionKeys = ['price_min', 'price_max', 'unit_price_min', 'unit_price_max']
      const displayKeys = ['pro_priority_display', 'certification_divination_priority_display']
      // 全部入りの絞り込みの時は絞り込み対象のキーをすべて返す
      if (facetGroupKey === FACET_GROUP.ALL.key) {
        const conditionKeyAll: string[] = Object.values(groupedConditionOptions.value).flatMap(
          (groupedConditionOption: ConditionOptionGroup) => {
            return groupedConditionOption.options
              .flatMap(conditionOptionCommons => conditionOptionCommons.master.valuesList)
              .map((value: serviceSearchOptionValue.AsObject) => {
                return value.valueKey
              })
          }
        )
        // 重複するキーを排除してリターン
        // サービス価格、文字単価はvaluesListに対象のキーが入ってこないので、対象のキーを配列に代入して渡してあげる
        return [...new Set(conditionKeyAll), ...priceConditionKeys, ...displayKeys]
      }

      // 全部入り以外は対象のファセットグループのキーを返す
      const conditionKeys: string[] = groupedConditionOptions.value[facetGroupKey].options
        .flatMap((conditionOptionCommon: ConditionOptionCommon) => {
          return conditionOptionCommon.master.valuesList
        })
        .map((value: serviceSearchOptionValue.AsObject) => {
          return value.valueKey
        })
      // サービス価格、文字単価はvaluesListに対象のキーが入ってこないので、対象のキーを配列に代入して渡してあげる
      if (facetGroupKey === FACET_GROUP.PRICES.key) {
        return [...new Set(conditionKeys), ...priceConditionKeys]
      }
      return [...new Set(conditionKeys)]
    }

    /**
     * 絞り込みが選択されているかどうかを判定する
     */
    const judgeSelectedCondition = (facetGroupKey: string): boolean => {
      const conditionOptionKeys = getSearchConditionKeys(facetGroupKey)
      const isSelected = Object.keys(selectedSearchConditionAll)
        .filter(key => {
          return !isFalsyOrEmpty(selectedSearchConditionAll[key], key)
        })
        .some(selectedSearchConditionKey => {
          return (
            isSelectedPriceRange(selectedSearchConditionKey, conditionOptionKeys) ||
            conditionOptionKeys.includes(selectedSearchConditionKey)
          )
        })
      return isSelected
    }

    const isFalsyOrEmpty = (value, searchConditionKey): boolean => {
      if (!value) {
        return true
      }
      if (Array.isArray(value)) {
        return value.length === 0
      }
      if (typeof value === 'object') {
        return Object.keys(value).length === 0
      }
      if (typeof value === 'string' && isIgnoreSearchConditionKey(searchConditionKey)) {
        return value === '0'
      }
      return false
    }

    /**
     * 検索条件の値が文字列の'0'の時にfalseと判定するかどうか
     * @param key
     */
    const isIgnoreSearchConditionKey = (key: string) => {
      const IGNORE_KEYS = ['service_kind']
      return !IGNORE_KEYS.includes(key)
    }

    /**
     * サービス価格または文字単価が選択されているか
     */
    const isSelectedPriceRange = (selectedKey: string, conditionOptionKeys: string[]): boolean => {
      if (selectedKey === 'price_min' || selectedKey === 'price_max') {
        return conditionOptionKeys.includes('service_price_range')
      }
      if (selectedKey === 'unit_price_min' || selectedKey === 'unit_price_max') {
        return conditionOptionKeys.includes('unit_price')
      }
    }

    /**
     * 選択状態をクリアする
     */
    const onClear = (facetGroupKey: string): void => {
      const conditionOptionKeys = getSearchConditionKeys(facetGroupKey)
      const clearCondition = {}
      conditionOptionKeys.forEach(conditionOptionKey => {
        if (conditionOptionKey) {
          clearCondition[conditionOptionKey] = emptySearchConditionAll[conditionOptionKey]
        }
      })
      assignReactive(selectedSearchConditionAll, clearCondition)
    }

    /**
     * セレクトボックスを開く前の状態に戻す
     */
    const onCloseSelectBox = (facetGroupKey: string): void => {
      const conditionOptionKeys = getSearchConditionKeys(facetGroupKey)
      const resumeCondition = {}
      conditionOptionKeys.forEach(conditionOptionKey => {
        if (conditionOptionKey) {
          resumeCondition[conditionOptionKey] = selectedSearchConditionAllClone[conditionOptionKey]
        }
      })
      assignReactive(selectedSearchConditionAll, resumeCondition)
    }

    const setOptionAttributes =
      inject<(condition: ChangeConditionObject, emitChangeEvent?: boolean) => void>(
        'setOptionAttributes'
      )

    const onSearch = (closeModal: boolean): void => {
      const values = selectedSearchConditionAll
      const conditionOptionKeys = getSearchConditionKeys(FACET_GROUP.ALL.key)
      conditionOptionKeys.forEach((conditionOptionKey, index) => {
        // 多重にルータープッシュしないように最後の検索条件の時だけルーターにプッシュするようにする
        const isLastIndex = index === conditionOptionKeys.length - 1
        setOptionAttributes(
          {
            key: conditionOptionKey,
            value: values[conditionOptionKey]
          },
          isLastIndex
        )
      })
      if (closeModal) {
        onCloseSearchModalFull()
      }
    }

    const isChangedServiceKind = ref(false)

    const isShowFullModal = ref(false)
    const showSearchModalFull = (): void => {
      isShowFullModal.value = true
    }
    const onCloseSearchModalFull = (): void => {
      onCloseSelectBox(FACET_GROUP.ALL.key)
      isShowFullModal.value = false
      isChangedServiceKind.value = false
    }

    onMounted(() => {
      window.addEventListener('scroll', switchSearchConditionPosition)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', switchSearchConditionPosition)
    })

    return {
      FACET_GROUP,
      elRoot,
      isFixed,
      groupedConditionOptions,
      switchSearchConditionPosition,
      onClear,
      onSearch,
      onCloseSelectBox,
      judgeSelectedCondition,
      isChangedServiceKind,
      isConditionChanged,
      isShowFullModal,
      showSearchModalFull,
      onCloseSearchModalFull,
      allConditionOptions
    }
  }
})

export default serviceSearchCondition
